module.exports = __webpack_public_path__ + "static/img/news_qrcode.d7d8cb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news_qrcode.jpg
// module id = TqZJ
// module chunks = 1